import { computed, observable } from 'mobx';
import { IInvoiceServiceItemBlockStyles } from '~/types/block-styles.types';
import type { CXInvoiceBlock } from '~/components/ClientExperience/OneFlow/models/cx-invoice-block.model';
import { CXServiceItemBlock } from '~/components/ClientExperience/OneFlow/models/cx-service-item-block.model';
import { IInvoiceServiceItemBlockResponse } from '~/types/server.types';
import type { CXRootStore } from '~/components/ClientExperience/stores/cx-root.store';
import type { FlowRevision } from '~/models/flow-revision.model';

export class CXInvoiceServiceItemBlock extends CXServiceItemBlock {
    type: 'invoice_service_item_block';
    @observable styles: IInvoiceServiceItemBlockStyles;

    constructor(
        block: IInvoiceServiceItemBlockResponse,
        flowRevision: FlowRevision<CXRootStore>,
        rootStore: CXRootStore
    ) {
        super(block, flowRevision, rootStore);
        this.type = block.type;
        this.connected_variable_id = block.connected_variable_id;
    }

    @computed
    get invoiceBlock(): CXInvoiceBlock {
        let { parent } = this;

        while (parent && parent.type !== 'invoice_container_block') {
            parent = parent.parent;
        }

        return parent as CXInvoiceBlock;
    }

    @computed
    get selectedQuantity(): number {
        return this.service_item.quantity;
    }
}
